module.exports = __webpack_public_path__ + "img/icon2@2x.d390b40d.png";